export enum GameStatesEnum {
    // game loading states
    GET_INIT_RESPONSE_STATE = 'GET_INIT_RESPONSE_STATE',
    BEFORE_LOADING_STATE = 'BEFORE_LOADING_STATE',
    LOADING_STATE = 'LOADING_STATE',
    INIT_STATE = 'INIT_STATE',
    DISPLAY_SPLASH_SCREEN_STATE = 'DISPLAY_SPLASH_SCREEN_STATE',

    // round/features logic states
    RESTORE_STATE = 'RESTORE_STATE',
    IDLE_STATE = 'IDLE_STATE',
    START_ROUND_STATE = 'START_ROUND_STATE',
    GAMBLE_STATE = 'GAMBLE_STATE',
    FINAL_STATE = 'FINAL_STATE',
    STOP_ROUND_STATE = 'STOP_ROUND_STATE',

    // reels spinning states
    START_SPIN_STATE = 'START_SPIN_STATE',
    GET_SPIN_RESPONSE_STATE = 'GET_SPIN_RESPONSE_STATE',
    STOP_SPIN_STATE = 'STOP_SPIN_STATE',
    BET_COOLDOWN_STATE = 'BET_COOLDOWN_STATE',

    // free spins states
    FREE_SPINS_ACTIVATE_STATE = 'FREE_SPINS_ACTIVATE_STATE',
    FREE_SPINS_INTRO_STATE = 'FREE_SPINS_INTRO_STATE',
    FREE_SPINS_RETRIGGER_STATE = 'FREE_SPINS_RETRIGGER_STATE',
    FREE_SPINS_SUMMARY_STATE = 'FREE_SPINS_SUMMARY_STATE',

    // winnings states
    CASCADE_STATE = 'CASCADE_STATE',
    REGULAR_WINNINGS_STATE = 'REGULAR_WINNINGS_STATE',
    BIG_WIN_STATE = 'BIG_WIN_STATE',
    LINE_BY_LINE_STATE = 'LINE_BY_LINE_STATE',

    // cascade
    CASCADE_SPIN_STATE = 'CASCADE_SPIN_STATE',

    // multiplier
    MULTIPLIER_STATE = 'MULTIPLIER_STATE',
}
